import React from 'react';
import { differenceInDays } from 'date-fns';
export const useCenteredDayIndex = ({ openedDate, backDate, outDate, openDate }) => {
    return React.useCallback((minDate) => {
        if (openedDate) {
            return differenceInDays(openedDate, minDate);
        }
        else if (backDate) {
            return differenceInDays(backDate, minDate);
        }
        else if (outDate) {
            return differenceInDays(outDate, minDate);
        }
        return differenceInDays(openDate, minDate);
    }, [openedDate, backDate, outDate, openDate]);
};
